import { render, staticRenderFns } from "./FabricAlignmentDisclaimer.vue?vue&type=template&id=8e71ee0c&"
import script from "./FabricAlignmentDisclaimer.vue?vue&type=script&lang=ts&"
export * from "./FabricAlignmentDisclaimer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports